var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowupright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17773 13.8555C11.2832 13.8555 13.8555 11.2832 13.8555 8.17773C13.8555 5.07227 11.2773 2.5 8.17188 2.5C5.07227 2.5 2.5 5.07227 2.5 8.17773C2.5 11.2832 5.07227 13.8555 8.17773 13.8555ZM9.9707 9.625C9.70703 9.625 9.53125 9.44336 9.53125 9.15039V8.19531L9.61328 7.32227L8.80469 8.18945L6.74219 10.2578C6.6543 10.3516 6.53711 10.3984 6.39062 10.3984C6.12695 10.3984 5.94531 10.2227 5.94531 9.94727C5.94531 9.82422 6.00391 9.70703 6.0918 9.61328L8.16016 7.55078L9.03906 6.73633L8.21289 6.82422H7.19922C6.91211 6.82422 6.72461 6.6543 6.72461 6.39062C6.72461 6.12109 6.90625 5.95117 7.19336 5.95117H9.89453C10.2109 5.95117 10.4102 6.09766 10.4102 6.45508V9.14453C10.4102 9.42578 10.2344 9.625 9.9707 9.625Z",
    fill: "#8F9397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowupright);
export default __webpack_public_path__ + "static/media/Arrow up right.43a30ebb1e45c99c246e489175aaa5a4.svg";
export { ForwardRef as ReactComponent };